import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, defaultLang } from "../lib/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("stayzen_lang") || defaultLang);

  useEffect(() => {
    localStorage.setItem("stayzen_lang", lang);
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: translations[lang] }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be within LanguageProvider");
  return ctx;
};
